const SPLIT_CHARS_REGEX = /[-_]+/

export const splitByCommonChars = (input: string) => input.split(SPLIT_CHARS_REGEX)

export const trimLeadingSlashes = (input: string) => input.replace(/^\/+/g, '')